import { useEffect, useState } from "react";
import { CollectionDefaultValue } from "../../defalult/CollectionDefaultValue";
import { NftDefaultValue } from "../../defalult/NftDefaultValue";
import { BreadCrump } from "../BreadCramp/BreadCrump";
import { MarketplaceNavbar } from "../Marketplace/MarketplaceNavbar/MarketplaceNavbar";
import { ProfileSidebar } from "../Profile/ProfileSidebar/ProfileSidebar";
import { BannerHeader, BreadcrumpWrapper, Shadow, SingleCollectionMain } from "../SingleCollection/SingleCollection.styled";
import { UserMainContentWrapper, UserWrapper } from "./User.styled";
import { UserMainContent } from "./UserMainContent/UserMainContent";
import { UserNavbar } from "./UserNavbar/UserNavbar";
import { toggleCreateCollectionModal } from "../../store/app/appSlice";

const tabList = ["Collected", "Creаted", "Collections"];

const Nfts = NftDefaultValue;
const Collections = CollectionDefaultValue;

const activeComponent = {
  Collected: <UserMainContent products={Nfts} />,
  Creаted: <UserMainContent products={Nfts} />,
  Collections: <UserMainContent products={Collections} collection={true} />,
};

export const User = ({ MyProfile = true }) => {
  const [activeTab, setActiveTab] = useState("Collected");

  return (
    <UserWrapper>
      <BannerHeader>
        <Shadow />
        <img src='../../../assets/img/default/collection/2.png' alt='banner' />
      </BannerHeader>
      <div className='container'>
        <BreadcrumpWrapper>
          <BreadCrump />
        </BreadcrumpWrapper>
        <SingleCollectionMain>
          <ProfileSidebar user={true} />
          <UserMainContentWrapper>
            <UserNavbar setActiveTab={setActiveTab} tabList={tabList} activeTab={activeTab} MyProfile={MyProfile} />
            {activeComponent[activeTab]}
          </UserMainContentWrapper>
        </SingleCollectionMain>
      </div>
    </UserWrapper>
  );
};
